"use client"
import { Truck, Hammer, TreeDeciduous, Box, Paintbrush, CheckCircle, FileText, Grid } from "lucide-react"
import { Card, CardContent, CardHeader, CardTitle } from "./ui/Card"

/**
 * Category-based KPI cards for cost codes
 * @param {Object} props
 * @param {Array} props.codes - Array of cost codes
 * @param {boolean} props.loading - Loading state
 */
/**
 * Dynamic category-based KPI cards for cost codes
 * @param {Object} props
 * @param {Array} props.codes - Array of cost codes
 * @param {boolean} props.loading - Loading state
 * @param {Function} props.onSelectCategory - Callback when a category card is clicked
 */
const CountsCards = ({ codes = [], loading, onSelectCategory }) => {
  // Group codes by category
  // Group codes by category with counts of total, active, and used
  const categories = codes.reduce((map, { category, active, isUsed }) => {
    if (!map[category]) map[category] = { total: 0, active: 0, used: 0 }
    map[category].total += 1
    if (active) map[category].active += 1
    if (isUsed) map[category].used += 1
    return map
  }, {})

  // Icon mapping
  const iconMap = {
    Logistics: Truck,
    Erection: Hammer,
    'Glulam / CLT': TreeDeciduous,
    'Misc Steel': Box,
    Coatings: Paintbrush,
    'QA & Rework': CheckCircle,
    'Change Order': FileText,
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mb-8">
      {Object.entries(categories).map(([category, data]) => {
        const Icon = iconMap[category] || Grid
        return (
        <Card
          key={category}
          onClick={() => onSelectCategory && onSelectCategory(category)}
          className="bg-gray-800 border border-gray-700 rounded-lg shadow hover:shadow-lg transform hover:scale-105 transition duration-150 ease-in-out cursor-pointer"
        >
            <CardHeader className="flex items-center gap-3 border-b border-gray-700 px-4 py-2">
              <Icon className="h-6 w-6 text-indigo-400" />
              <CardTitle className="text-base font-semibold text-white uppercase">{category}</CardTitle>
            </CardHeader>
            <CardContent className="px-4 py-4 text-center">
              <div className="text-3xl font-extrabold text-white">{loading ? '...' : data.total}</div>
              {!loading && (
                <div className="mt-2 space-y-1">
                  <div className="text-sm text-green-400"><span className="font-medium">Active:</span> {data.active}</div>
                  <div className="text-sm text-yellow-400"><span className="font-medium">Used:</span> {data.used}</div>
                </div>
              )}
            </CardContent>
            </Card>
        )
      })}
    </div>
  )
}

export default CountsCards
